import Countries from ".";

export const countryRoutes = [
  {
    path: "/countries",
    element: <Countries />,
  },
];
